var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubscription(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.757,
    height: 15.098,
    viewBox: "0 0 17.757 15.098",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_2",
    "data-name": "Union 2",
    d: "M-14596.025,3643.1a.444.444,0,0,1-.44-.44,1.1,1.1,0,0,0-1.095-1.1.44.44,0,0,1-.439-.439v-11.145a.44.44,0,0,1,.439-.44,1.1,1.1,0,0,0,1.095-1.1.444.444,0,0,1,.44-.439h13.8a.441.441,0,0,1,.44.439,1.1,1.1,0,0,0,1.1,1.1.44.44,0,0,1,.439.44v11.145a.44.44,0,0,1-.439.439,1.1,1.1,0,0,0-1.1,1.1.441.441,0,0,1-.44.44Zm-1.1-12.731v10.364a1.981,1.981,0,0,1,1.487,1.487h13.024a1.975,1.975,0,0,1,1.487-1.487l0-10.364a2,2,0,0,1-1.491-1.491h-13.024A1.991,1.991,0,0,1-14597.121,3630.368Zm10.756,7.814a.441.441,0,0,1-.439-.44.441.441,0,0,1,.439-.44h3.484a.439.439,0,0,1,.439.44.439.439,0,0,1-.439.44Zm-7.972,0a.434.434,0,0,1-.418-.308l-1.029-3.29a.442.442,0,0,1,.136-.473.447.447,0,0,1,.487-.048l1.682.9,1.025-1.824a.431.431,0,0,1,.382-.223.435.435,0,0,1,.381.223l1.025,1.824,1.678-.9a.439.439,0,0,1,.487.048.446.446,0,0,1,.14.473l-1.029,3.29a.442.442,0,0,1-.422.308Zm.322-.879h3.884l.611-1.96-1.113.594a.441.441,0,0,1-.59-.172l-.85-1.517-.854,1.517a.44.44,0,0,1-.586.172l-1.113-.594Zm7.649-1.315a.441.441,0,0,1-.439-.44.441.441,0,0,1,.439-.44h3.484a.439.439,0,0,1,.439.44.439.439,0,0,1-.439.44Zm0-2.195a.441.441,0,0,1-.439-.439.441.441,0,0,1,.439-.44h3.484a.439.439,0,0,1,.439.44.439.439,0,0,1-.439.439Z",
    transform: "translate(14598 -3628.001)",
    fill: "#3b57a9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscription);
export default __webpack_public_path__ + "static/media/subscription.4b4ba1326015ea744925ab8f8d6ac6cc.svg";
export { ForwardRef as ReactComponent };